import React from "react";

import { DomainsCircle } from "../../graphics/domains_circle";

/*
 * Main
 */

export const Overview = (): React.ReactElement => {
    return (
        <div className="report-overview-wrapper">
            <p>
                Analysis of the FFI identified 27 validated constructs related to spiritual formation across the seven
                groups of participants. These constructs have been grouped into a model with four major domains, along
                with a propositional Head survey and a spiritual disciplines Hand survey. In the following pages, a
                definitional overview will be provided for these domains, followed by a listing of specific constructs
                that make up each domain.
            </p>

            <div className="overview-divider" />

            <h2 className="large">Explore your results by domain.</h2>
            <p className="text-align-center">Click on the interactive graphic below to navigate between domains.</p>

            <DomainsCircle />
        </div>
    );
};
